import { AsphaltMixDesigns } from '../../../cimsPage/instances/materials'
import { Simple } from '../../common'

const object = 'Asphalt Mix Design'
const page = AsphaltMixDesigns

export const CreateAsphaltMixDesign = Simple({
  id: 'FB231484-0821-466F-840D-97A1D0BEE8D6',
  action: 'Create',
  object,
  page,
})

export const EditAsphaltMixDesign = Simple({
  id: 'DD5EBC5D-1B7B-44A3-AB76-49C0433D05EF',
  action: 'Edit',
  object,
  page,
})

export const ViewAsphaltMixDesign = Simple({
  id: '25B8445E-C62D-47D5-8FA3-1C5544FD0D24',
  action: 'View',
  object,
  page,
})

export type AsphaltMixDesignPermissionItem =
  | typeof CreateAsphaltMixDesign
  | typeof EditAsphaltMixDesign
  | typeof ViewAsphaltMixDesign
